import { Observable } from 'rxjs';

import { ShipmentTimelineEvent } from './+state/shipment-timeline-events.models';

export abstract class ShipmentTimelineEventsServiceBase {
    public abstract getShipmentTimelineEvents(
        shipmentId: string
    ): Observable<ShipmentTimelineEvent[]>;

    public abstract createShipmentTimelineEvent(
        shipmentId: string,
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        payload: any
    ): Observable<ShipmentTimelineEvent>;

    public abstract updateShipmentTimelineEvent(
        shipmentId: string,
        shipmentTimelineEventId: string,
        changes: Partial<ShipmentTimelineEvent>
    ): Observable<ShipmentTimelineEvent>;

    public abstract confirmShipmentTimelineEvent(
        shipmentId: string,
        shipmentTimelineEventId: string,
        changes: Partial<ShipmentTimelineEvent>
    ): Observable<ShipmentTimelineEvent>;
}
